import { Node3D } from 'feng3d-three';
import { SkeletonUtils } from '../thirdparty/three/imports';

export class SkeletonUtils3D
{
    static clone(source: Node3D)
    {
        const root = SkeletonUtils.clone(source._group);

        const node = new Node3D();
        node._group = root as any;

        return node;
    }
}
